module.exports = __webpack_public_path__ + "static/media/blue_balloon.95e76497.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/balloons/blue_balloon.svg
// module id = 621
// module chunks = 0